import { Comment, MessageEntityType, PostCommentPayload } from '../comments.model';

/**
 * NGXS Actions for Comments State Management
 */

/**
 * Load comments for one or more entities
 */
export class LoadComments {
  static readonly type = '[Comments] Load Comments';
  constructor(
    public entityIds: number[],
    public entityType: MessageEntityType,
    public limit?: number,
  ) {}
}

/**
 * Set comments in state (used after successful load)
 */
export class SetComments {
  static readonly type = '[Comments] Set Comments';
  constructor(
    public entityId: number,
    public entityType: MessageEntityType,
    public comments: Comment[],
  ) {}
}

/**
 * Add a new comment (parent or reply)
 */
export class AddComment {
  static readonly type = '[Comments] Add Comment';
  constructor(public payload: PostCommentPayload) {}
}

/**
 * Add comment success - update state with new comment
 */
export class AddCommentSuccess {
  static readonly type = '[Comments] Add Comment Success';
  constructor(public comment: Comment) {}
}

/**
 * Clear comments for a specific entity
 */
export class ClearComments {
  static readonly type = '[Comments] Clear Comments';
  constructor(
    public entityId: number,
    public entityType: MessageEntityType,
  ) {}
}

/**
 * Set loading state
 */
export class SetLoading {
  static readonly type = '[Comments] Set Loading';
  constructor(public loading: boolean) {}
}

/**
 * Set error state
 */
export class SetError {
  static readonly type = '[Comments] Set Error';
  constructor(public error: string | null) {}
}

/**
 * Mark a message as read (viewed)
 */
export class MarkMessageAsRead {
  static readonly type = '[Comments] Mark Message As Read';
  constructor(
    public messageId: string,
    public entityId: number,
    public entityType: MessageEntityType,
  ) {}
}
